import { Directive, EventEmitter, Output, TemplateRef } from '@angular/core';

@Directive({
  selector: '[psUiTableCellTemplate]',
})
export class TableCellTemplateDirective {
  @Output()
  public tap = new EventEmitter();

  constructor(public template: TemplateRef<unknown>) {}
}
